import type { PricingRule } from '@/types';

export interface PricingRuleFormValues {
  id: string;
  enabled?: boolean;
  provider?: string;
  provider_path?: string;
  public_model?: string;
  upstream_model?: string;
  route_id?: string;
  models?: string;
  input_usd_per_million_tokens?: number;
  output_usd_per_million_tokens?: number;
  cache_read_usd_per_million_tokens?: number;
  cache_write_usd_per_million_tokens?: number;
  image_usd_per_million_tokens?: number;
  audio_usd_per_million_tokens?: number;
  fixed_price_usd?: number;
  price_multiplier?: number;
  priority?: number;
  free?: boolean;
}

export function mergePricingRuleDraft(
  rule: PricingRule | null,
  values: PricingRuleFormValues,
) {
  const parsedModels = (values.models || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
  const next: PricingRule = {
    ...rule,
    ...values,
    models: parsedModels,
    price_multiplier: values.price_multiplier ?? 1,
  };
  if (rule && !('enabled' in rule) && next.enabled === true) {
    delete next.enabled;
  }
  if (rule && !('price_multiplier' in rule) && next.price_multiplier === 1) {
    delete next.price_multiplier;
  }
  if (rule && !('models' in rule) && parsedModels.length === 0) {
    delete next.models;
  }
  return next;
}
